module.exports = __webpack_public_path__ + "img/weixin.d14aff85.png";